import { useEffect, useState } from 'react';
import { CatalogAPI } from '../lib/api';

const CACHE_KEY = 'dz_suppliers_cache_v1';

// In-flight promise (avoids parallel fetches when many ProductCards mount at once)
let _inflight = null;

const readCache = () => {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

const writeCache = (list) => {
  try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(list)); } catch { /* quota exceeded / private mode — cache write is best-effort */ }
};

/**
 * Hook léger pour récupérer la liste des fournisseurs (cache sessionStorage + dédupe).
 * Retourne un objet { byId: { [id]: supplier } }
 */
export function useSuppliers() {
  const [byId, setById] = useState(() => {
    const cached = readCache();
    if (!cached) return {};
    return Object.fromEntries(cached.map(s => [s.id, s]));
  });

  useEffect(() => {
    if (Object.keys(byId).length > 0) return; // already loaded
    if (!_inflight) {
      _inflight = CatalogAPI.suppliers()
        .then(list => { writeCache(list); return list; })
        .catch(() => [])
        .finally(() => { _inflight = null; });
    }
    let cancelled = false;
    _inflight?.then(list => {
      if (cancelled || !list?.length) return;
      setById(Object.fromEntries(list.map(s => [s.id, s])));
    });
    return () => { cancelled = true; };
  }, [byId]);

  return { byId };
}
